module.exports = __webpack_public_path__ + "static/media/logo.dc8a5bad.svg";